import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { MasterMedicine } from '../../../../apis/master-medicines/types';
import ImageEditor from '../../../FormEditors/ImageEditor';

interface MasterMedicineEditorProps {
  form: UseFormReturn<MasterMedicine>;
}

const MasterMedicineImageEditor = ({ form }: MasterMedicineEditorProps) => {
  return <ImageEditor control={form.control} name="image_url" height="100px" width="310px" suggestedSize="620x200px" />;
};

export default MasterMedicineImageEditor;
